import React, { useState, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import { List, ListItem, ListItemIcon, ListItemText, Typography, Collapse } from '@mui/material';
import c from 'classnames';

import SettingsMenu from './components/SettingsMenu';
import { ReactComponent as ArrowUpIcon } from '../../assetsNew/icons/menu/keyboard-arrow-up.svg';
import { ReactComponent as ArrowDownIcon } from '../../assetsNew/icons/menu/keyboard-arrow-down.svg.svg';
import { matchRoute } from '../../utils/matchRoute';
import { menuSections, subMenuObjects } from '../../utils/menu';

import './_menu.scss';

const Menu = () => {
  const { pathname } = useLocation();
  const { data: { is_group_admin } } = useSelector(s => s.account);
  const { data: { access_token } } = useSelector(s => s.getSendbirdToken);
  const { unreadMessagesCount } = useSelector(s => s.sendbirdUnreadMessages);
  const [expand, setExpand] = useState(subMenuObjects(is_group_admin));

  const handleClick = key => {
    setExpand({
      ...expand,
      [key]: !expand[key]
    });
  };

  const filterItems = items => items.filter(item => !item.unreadBadge || Boolean(access_token));

  const renderMenuItems = items => (
    filterItems(items).map(element => {
      let active = element.path ? matchRoute(pathname, element.path) : false;

      return element.path ? (
        <Link to={element.path} key={element.id} className={c('menu-item', { 'active': active })}>
          {active && <div className="active-line" />}
          <ListItemIcon>{element.icon}</ListItemIcon>
          <ListItemText className="text" primary={element.title} />
          {element.unreadBadge && Boolean(unreadMessagesCount) && <div className="unread-dot" />}
        </Link>
      ) : (
        <Fragment key={element.id}>
          <ListItem button className={c('menu-item')} onClick={() => handleClick(element.id)}>
            <ListItemIcon>
              <>
                {element.icon}
              </>
            </ListItemIcon>
            <ListItemText className="text" primary={element.title} />
            {
              element.more
                ? expand[element.id] ? <ArrowUpIcon className="expandIcon" /> : <ArrowDownIcon className="expandIcon" />
                : null
            }
          </ListItem>
          {
            element.more && expand[element.id] && (
              <Collapse in={Boolean(expand)} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {
                    element.more.map(el => {
                      active = matchRoute(pathname, el.path);

                      return (
                        <Link to={el.path} className={c('menu-item sub', { 'active': active })} key={el.id} >
                          {active && <div className="active-line" />}
                          <ListItemIcon>{el.icon}</ListItemIcon>
                          <ListItemText className="text" primary={el.title} />
                        </Link>
                      );
                    })
                  }
                </List>
              </Collapse>
            )
          }
        </Fragment>
      );
    })
  );

  const navClass = c('menu-nav scrollbar hide');

  return (
    <div className="menu">
      <List component="nav" className={navClass}>
        <div>
          <Typography className="menu-section">Menu</Typography>
          {menuSections(is_group_admin).map((section, i) => (
            <div key={i}>
              {section.title && <Typography className="menu-section small">{section.title}</Typography>}
              {renderMenuItems(section.items)}
            </div>
          ))}
        </div>
        <SettingsMenu isAdmin={is_group_admin} />
      </List>
    </div>
  );
};

export default Menu;